import PropTypes from 'prop-types';

import EmptySearchResults from '@/src/Search/components/EmptySearchResults';
import MultipleSearchVacancies from '@/src/Search/components/MultipleSearchVacancies';
import {LoadingWrapper} from '@/src/ui';

import MultipleSearchField from '../components/MultipleSearchField';
import css from '../styles/MultipleSearchLayout.module.css';
import MultipleSearchCourses from './MultipleSearchCourses';
import MultipleSearchUsers from './MultipleSearchUsers';
import SearchTabsNavigation from './SearchTabsNavigation';

const MultipleSearchLayout = ({
  vacanciesData,
  searchValue,
  onSearchValueChange,
  onSuccessfulApplicationCallback,
  coursesData,
  usersData,
  onShowCoursesClick,
  onShowPostsClick,
  onShowUsersClick,
  onShowClinicClick,
  onShowVacanciesClick,
  onTabClick,
  activeSearchType,
  isLoading,
  currentUserId,
  clinicsData,
  postsData,
}) => {
  return (
    <div className={css.widget}>
      <MultipleSearchField
        onSearchValueChange={onSearchValueChange}
        searchValue={searchValue}
      />
      <LoadingWrapper isLoading={isLoading}>
        <SearchTabsNavigation
          onTabClick={onTabClick}
          activeSearchType={activeSearchType}
        />
        <div className={css.mainWrapper}>
          {Boolean(postsData?.length) && (
            <MultipleSearchCourses
              isPosts
              coursesData={postsData}
              onShowCoursesClick={onShowPostsClick}
            />
          )}
          {Boolean(coursesData?.length) && (
            <MultipleSearchCourses
              isPosts={false}
              coursesData={coursesData}
              onShowCoursesClick={onShowCoursesClick}
            />
          )}
          {Boolean(usersData?.length) && (
            <MultipleSearchUsers
              data={usersData}
              onShowClick={onShowUsersClick}
              currentUserId={currentUserId}
            />
          )}
          {Boolean(clinicsData?.length) && (
            <MultipleSearchUsers
              isClinic
              data={clinicsData}
              onShowClick={onShowClinicClick}
              currentUserId={currentUserId}
            />
          )}
          {Boolean(vacanciesData?.length) && (
            <MultipleSearchVacancies
              onSeeAllClick={onShowVacanciesClick}
              data={vacanciesData}
              onSuccessfulApplicationCallback={onSuccessfulApplicationCallback}
            />
          )}
          {Boolean(
            !usersData?.length &&
              !coursesData?.length &&
              !clinicsData?.length &&
              !vacanciesData?.length &&
              !isLoading
          ) && <EmptySearchResults />}
        </div>
      </LoadingWrapper>
    </div>
  );
};

MultipleSearchLayout.propTypes = {
  onSearchValueChange: PropTypes.func.isRequired,
  onSuccessfulApplicationCallback: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired,
  coursesData: PropTypes.array,
  usersData: PropTypes.array,
  clinicsData: PropTypes.array,
  vacanciesData: PropTypes.array,
  onShowCoursesClick: PropTypes.func.isRequired,
  onShowUsersClick: PropTypes.func.isRequired,
  onShowClinicClick: PropTypes.func.isRequired,
  onShowVacanciesClick: PropTypes.func.isRequired,
  onTabClick: PropTypes.func.isRequired,
  activeSearchType: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  currentUserId: PropTypes.string,
};

export default MultipleSearchLayout;
